import { Component } from '@angular/core';
import { AuthenticationService } from '@kaiser-software/chassis-core';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: [ './dashboard.component.scss' ]
})
export class DashboardComponent {

    constructor(public auth: AuthenticationService) {
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/dashboards/pages/dashboard/dashboard.component.ts